<template>
  <div class="task_pop_bg">
    <!-- 标题 -->
    <div class="topSpot"></div>
    <div class="bottomSpot"></div>
    <div class="topBorder"></div>

    <div class="titleLine">
      <div class="info_title">
        <div class="titleLine_name">
          <span class="leftLine"></span
          ><span style="color: #2ac1ff">{{ resultData.messageTypeName }}</span>
        </div>
        <div class="closeBtn" @click="close"></div>
      </div>
    </div>
    <div class="middleOutLine">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <div class="messageRow notisfy">
          <div class="circleType">{{ resultData.messageTypeName }}</div>
          <div class="margin_0_10">
            {{ resultData.categoryName || resultData.messageTypeName }}
          </div>
          <div class="margin_left">
            {{ levelName }}
          </div>
        </div>
        <div class="notisfy">
          <span style="margin-right: 20px"
            >时间：{{ resultData.dataTime }} </span
          >来源：{{ resultData.sourceName }}
        </div>
        <div class="notisfy">详情</div>
        <div class="notisfy" style="margin-left: 7%">
          {{ resultData.content }}
        </div>

        <el-form-item v-if="fileList.length > 0">
          <!-- :disabled="!IsEdit" :on-remove="handleRemove"-->
          <el-upload
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :http-request="uploadAvatar"
            :before-upload="beforeAvatarUpload"
            :file-list="fileList"
            :disabled="true"
          >
            <i class="addIcon"></i>
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>

        <div class="mapBox">
          <!--  ref="map-mapview" -->
          <div class="covermap">
            <div
              class="map"
              id="allmap"
              style="width: 100%; height: 100%; z-index: 2 !important"
            ></div>
          </div>

          <div class="coverbg"></div>
        </div>

        <!-- :disabled="!IsEdit" :on-remove="handleRemove"-->
        <el-form-item v-if="fileList.length > 0">
          <el-upload
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview2"
            :http-request="uploadAvatar"
            :before-upload="beforeAvatarUpload"
            :file-list="fileList2"
            :disabled="isfinish"
          >
            <i class="addIcon"></i>
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible2">
            <img width="100%" :src="dialogImageUrl2" alt="" />
          </el-dialog>
        </el-form-item>

        <!-- <el-form-item
          style="margin-top: 10px; display: flex; justify-content: flex-end"
          v-if="showRengong && !handleStatus"
        >
          <el-button @click="submitForm('ruleForm')">确认</el-button>
        </el-form-item> -->
        <!-- <el-form-item
          style="margin-top: 10px; display: flex; justify-content: flex-end"
        >
          <el-button @click="handleTask()" style="margin-left: 15px"
            >发任务</el-button
          >
          <el-button @click="handleEmergency()" style="margin-left: 15px"
            >转应急</el-button
          >
        </el-form-item> -->
        <!-- <el-form-item prop="content" v-if="showRengong" label="备注">
          <el-input type="textarea" v-model="ruleForm.content"></el-input>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="msgfooter">
      <el-button @click="handleTask()" style="margin-left: 15px"
        >发任务</el-button
      >
      <el-button @click="handleEmergency()" style="margin-left: 15px"
        >转应急</el-button
      >
    </div>
    <div class="bottomBorder"></div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import waitAll from "../../../../../../utils/src/waitAll";
import {
  handleMsg,
  getMsgInfo,
  saveMsg,
  queryDevice,
} from "../../../../../../request/msgApi";
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        content: "",
      },
      rules: {
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      IsEdit: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imgList: [],
      fileList: [],
      fileList2: [],
      dialogVisible2: false,
      dialogImageUrl2: "",
      delFileList: [],
      center: [],
      center2: [],
      isHavePosition: false,
      mapInstance: "",
      currentValue: "",
      preValue: "",
      resultData: {},
      handleStatus: false, //false为待处理，true为已处理
      showRengong: false,
      isfinish: false,
      levelName: "",
      msgTypeName: "",
      handleWay: "",
      handleWayOptions: [
        {
          value: "task",
          label: "发任务",
        },
        {
          value: "emergency",
          label: "转应急",
        },
      ],
    };
  },
  filters: {
    getlevelName(val) {
      if (val == "warning_level_1") {
        return "一级";
      } else if (val == "warning_level_2") {
        return "二级";
      } else if (val == "warning_level_3") {
        return "三级";
      }
    },
  },
  props: {
    msgId: {
      type: String,
      default: "",
    },
    isShowMsgDetail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
    ...mapState({
      getEarlymsg: (state) => state.earlyMsg,
    }),
  },
  created: function () {
    if (this.isShowMsgDetail && this.msgId) {
      this.getDetails();
    }
  },
  mounted: function () {},
  methods: {
    ...mapActions(["submitMsgTask"]),

    handleREngong() {
      // this.$emit("handleREN",false)
      this.showRengong = true;
    },
    handleRemark() {
      this.showRengong = true;
    },
    handleTask() {
      this.submitMsgTask(true);
      this.$emit("handleTask", this.resultData);
    },
    handleEmergency() {
      this.$confirm("确认转为应急事件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let path = `/plugin/Emergency/UI/NewEvent?MsgId=${this.resultData.id}`;
        this.$router.push(path);
      });
    },
    getDetails() {
      let that = this;
      let params = {
        id: this.msgId,
      };
      this.center = [];
      getMsgInfo(params).then((res) => {
        console.log("详细详情");
        console.log(res);
        let data = res.data;
        that.resultData = data;
        this.msgTypeName = data.messageTypeName || "";
        //

        if (data.status == "0") {
          that.handleStatus = false;
          that.isfinish = false;
          that.levelName = "";
        } else if (data.status == "10") {
          that.levelName = "未接通";
        } else if (data.status == "20") {
          that.levelName = "已接通";
        } else if (data.status == "1") {
          that.handleStatus = true;
          that.isfinish = true;
          that.showRengong = true;
          that.levelName = "";
          if (data.messageHandle?.images) {
            let fileList = data.messageHandle.images.split(",");
            fileList.forEach((item) => {
              let obj = {
                url: item,
              };
              that.fileList2.push(obj);
            });
          }
          that.ruleForm.content = data.messageHandle?.content;
        }
        if (data.longitude & data.latitude) {
          that.isHavePosition = true;
          this.center.push(data.longitude);
          this.center.push(data.latitude);
        }

        this.onDrawMap();
        //修改状态为已读
        // if (data.isRead != 1) {
        //   const updateParam = {
        //     id: data.id,
        //     isRead: 1,
        //   };

        //   this.updateMsgStatus(updateParam);
        // }

        if (data.images) {
          let fileList = data.images.split(",");
          fileList.forEach((item) => {
            let obj = {
              url: item,
            };
            that.fileList.push(obj);
          });
        }

        if (that.resultData.messageHandle) {
          that.ruleForm.confirmType = String(data.confirmType);
        }
      });
    },

    updateMsgStatus(msg) {
      saveMsg(msg).then((res) => {});
    },
    close() {
      this.$emit("closeMsgDetail", false);
    },
    toContent(val) {
      this.ruleForm.content = this.ruleForm.content + val;
    },
    handleRemove(file, fileList) {
      // console.log(file);
      // console.log(fileList)
      // console.log(this.fileList)
      let that = this;
      if (file.FileUrl) {
        // 最后提交的时候再删除
        this.delFileList.push(file);
        this.fileList2.forEach((item) => {
          if (item.FileUrl == file.FileUrl) {
            item.Validity = 0;
          }
        });
      }
      let arr = [];
      fileList.forEach((item) => {
        if (that.$route.query.type == "edit") {
          if (!item.FileUrl) {
            arr.push(item.raw);
          }
        } else {
          arr.push(item.raw);
        }
      });
      this.imgList = arr;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureCardPreview2(file) {
      this.dialogImageUrl2 = file.url;
      this.dialogVisible2 = true;
    },
    uploadAvatar(item) {
      this.imgList.push(item.file);
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    save() {
      let that = this;
      if (this.imgList.length > 0) {
        let uuid = ZJApp.ZJUtils.uuid();
        //先上传图片
        that.uploadAttch(uuid).then((r) => {
          console.log("图片结果");
          console.log(r);
          that.saveData(r);
        });
      } else {
        that.saveData("");
      }
    },
    saveData(r) {
      let imgUrlList = [];
      //如果有图片
      if (r && r.length > 0) {
        r.forEach((item) => {
          imgUrlList.push(item.DownloadPath);
        });
      }
      let that = this;
      let params = {
        id: that.resultData.id,
        type: "0", // 类型(0人工处理，1、转任务， 2、转应急)
        handler: ZJApp.ZJUser.current.UserName,
        handlerId: "",
        confirmType: this.ruleForm.confirmType,
        content: that.ruleForm.content,
        videos: "",
        audios: "",
        images: imgUrlList.join(","),
        sourceId: "", //关联任务id，非必传
      };
      handleMsg(params).then((res) => {
        console.log("人工处理预警结果");
        console.log(res);
        if (res.code == 0) {
          that.close();
        }
      });
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    //插入附件
    uploadAttch(feedid) {
      return new Promise((resolve, reject) => {
        let mediaList = this.imgList;
        var arr = [];
        mediaList.forEach((item) => {
          var option = {
            file: item,
            data: {
              module: "unifiedRelease", //模块名
              submodule: "Announcement", //子模块
              assocID: feedid, //业务ID
              uploader: ZJApp.ZJUser.current.UserName, //上传人
            },
            onProgress: () => {},
            onSuccess: () => {},
            onError: () => {},
          };
          arr.push(this.httpRequest(option));
        });

        waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    goCenter: function () {
      let that = this;
      // eslint-disable-next-line no-undef
      console.log("this.center");
      console.log(this.center);
      // if(this.center.length>0){
      // eslint-disable-next-line no-undef
      console.log("this.center");
      console.log(this.center);
      this.mapInstance.panTo(new BMap.Point(this.center[0], this.center[1]));
      that.addDom();
      // setTimeout(() => {
      //   if(that.isHavePosition){
      //     that.addDom();
      //   }else{
      //     that.addMarker(that.mapInstance,that.center)
      //   }

      // }, 1000);
      // }else{
      //   this.getMapCenter();
      //   setTimeout(() => {
      //     // eslint-disable-next-line no-undef
      //     this.mapInstance.panTo(new BMap.Point(this.center2[0], this.center2[1]));
      //     if(that.isHavePosition){
      //       that.addDom();
      //     }else{
      //       that.addMarker(that.mapInstance,that.center2)
      //     }
      //   }, 2000);
      // }
    },
    onDrawMap: function () {
      let center = this.center;
      var map = new BMap.Map("allmap");
      var point = new BMap.Point(center[0], center[1]);
      map.centerAndZoom(point, 12);
      var opts = { type: BMAP_NAVIGATION_CONTROL_SMALL };
      map.addControl(new BMap.NavigationControl(opts));
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画

      // 创建地图，并通过样式让地图填满窗口
      // let that = this;
      // this.$nextTick(function() {
      //   // eslint-disable-next-line no-undef
      //   $(function() {
      //     // 不传入 syscode 和 key ，或者值为空时，
      //     // zjumap 插件自动从 URL 地址
      //     // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
      //     // 中读取 syscode 和 key 的值。
      //     // eslint-disable-next-line no-undef
      //     $(".map").zjumap({
      //       syscode: "ZJMap",
      //       key: "EmergencyOneMap",
      //       loading: ".global-loading",
      //       loadingText: ".global-loading-text",
      //       //地图配置
      //       mapConfigs: {
      //         mapStyle: "",
      //         togglePanelVisiable: false,
      //         mapLayers: "DOM",
      //         clickToShowLocation: false,
      //         // reportGeo: true,
      //         // onGotGeo: function(e) {
      //         //   e.handled = true;
      //         //   if (that.marker) {
      //         //     that.marker.setPosition(
      //         //       e.map.newPoint(e.point.lng, e.point.lat)
      //         //     );
      //         //   } else {
      //         //     that.marker = that.addMarker(e.map, e.point);
      //         //   }
      //         //   that.dialogVisible2 = true;
      //         //   that.lat = e.point.lat;
      //         //   that.lng = e.point.lng;
      //         // },
      //         onMapCreated: function(e) {
      //           console.log("e")
      //           console.log(e)
      //           console.log(e.map.getLayerByName("DOM"));
      //           that.mapInstance = e.map;
      //            console.log(that.mapInstance)
      //           // e.map.clearAll();
      //           that.center2 = e.map.config.center;
      //           that.goCenter();
      //           // setTimeout(() => {
      //           //   that.addDom();
      //           // }, 1000);

      //         }
      //       }
      //     });
      //   });
      // });
    },
    addMarker: function (map, point) {
      if (!map) return null;
      this.marker = map.createOverlay(
        point,
        {
          url: "/lib/zjmap/Content/images/noposition.png",
          width: 100,
          height: 75,
          offsetX: 24,
          offsetY: 48,
        },
        null,
        {
          enableClicking: false,
        }
      );
      map.addOverlay(this.marker);
      return this.marker;
    },
    addDom: function () {
      if (!this.mapInstance) return;
      // var layer = this.mapInstance.getLayerByName("DOM");
      this.ComplexCustomOverlay.prototype = new BMap.Overlay();
      this.ComplexCustomOverlay.prototype.initialize = function (map) {
        // var layer = this.mapInstance.addOverlay;
        // console.log('layer')
        // console.log(layer)
        // if (layer && layer.addDom)
        this._map = map;
        // eslint-disable-next-line no-undef
        var $div = $("<div></div>");
        $div.append(this.getSvgContent());
        $div.css({
          width: "30rem",
          height: "30rem",
          "margin-left": "-15rem",
          "margin-top": "-15rem",
          position: "absolute",
        });
        this.mapInstance.getPanes().labelPane.appendChild($div);

        return $div;
      };
      let center = this.center;
      var myCompOverlay = new this.ComplexCustomOverlay(
        new BMap.Point(center[0], center[1])
      );

      this.mapInstance.addOverlay(myCompOverlay);
      // var label = new BMap.Label($div,{offset:new BMap.Size(20,-10)});
      //   marker.setLabel(label);
      //   layer.addDom(this.center[0], this.center[1], $div[0]);
      // }
    },
    // 复杂的自定义覆盖物
    ComplexCustomOverlay(point, text, mouseoverText) {
      this._point = point;
      this._text = text;
      this._overText = mouseoverText;
    },
    getSvgContent: function () {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        '  <div class="circle delay1"></div>' +
        '  <div class="circle delay2"></div>' +
        '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
  },
};
</script>
<style scoped lang="scss">
.task_pop_bg {
  width: 36.5%;
  position: fixed;
  left: 50%;
  top: 110px;
  z-index: 99999;
  margin-left: -18.2%;
  box-sizing: border-box;
  border-bottom-left-radius: 22px;
  .topBorder {
    width: 100%;
    height: 34px;
    background: url("../../../../../../assets/pop_tz.png") no-repeat;
    background-size: 100% 34px;
    position: relative;
  }
  .bottomBorder {
    width: 100%;
    height: 25px;
    background: url("../../../../../../assets/pop_bz.png") no-repeat;
    background-size: 100%;
  }
  .titleLine {
    width: 100%;
    box-sizing: border-box;
    background: rgba(15, 36, 69, 0.8);
    border-left: 1px solid #2ac1ff;
    border-right: 1px solid #2ac1ff;
    padding-bottom: 10px;
    position: relative;
    .info_title {
      width: 92%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #2ac1ff;
      padding-bottom: 10px;
    }
    .titleLine_name {
      display: flex;
      align-items: center;
      .leftLine {
        display: inline-block;
        width: 2px;
        height: 15px;
        margin-right: 10px;
        background: #2ac1ff;
      }
    }
    .closeBtn {
      width: 20px;
      height: 20px;
      background: url("../../../theme-default/src/img/close.png") no-repeat;
      background-size: 20px;
      position: absolute;
      right: 20px;
      top: 0px;
      z-index: 999999;
    }
  }
  .middleOutLine {
    height: 40.8rem;
    overflow: auto;
    width: 100%;
    padding: 0 10px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    background: rgba(15, 36, 69, 0.8);
  }
  .notisfy {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 3%;
    font-size: 12px;
    margin-bottom: 15px;
  }
  .mapBox {
    width: 100%;
    height: 274px;
    padding: 24px 20px 16px 26px;
    box-sizing: border-box;
    position: relative;
  }
  .coverbg {
    // width: 525px;
    width: 100%;
    height: 274px;
    background: url("../../../../../../assets/mapborder.png") no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .topSpot {
    width: 222px;
    height: 125px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    position: absolute;
    right: 15px;
    top: -62px;
    z-index: 12000;
  }
  .bottomSpot {
    width: 222px;
    height: 120px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    // background-size:cover;
    position: absolute;
    left: -35px;
    bottom: -45px;
    z-index: 10000;
  }
  .redLevel {
    color: #fb4d4e;
  }
  .yellowLevel {
    color: #fbda4e;
  }
  .blueLevel {
    color: #2ac1ff;
  }
  .circleType {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 20px;
    color: #fff;
    line-height: 50px;
    text-align: center;
    background: #29bfff;
  }
  .messageRow {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .margin_0_10 {
    margin: 0 10px;
  }
  .margin_left {
    margin-left: 10rem;
  }
  .covermap {
    position: absolute;
    top: 37px;
    left: 50%;
    width: 86%;
    height: 77%;
    z-index: 2;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .msgfooter {
    height: 45px;
    width: 100%;
    padding: 10px 20px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    background: rgba(15, 36, 69, 0.8);
    text-align: right;
  }
}
</style>
